import React from 'react';
const items = ['Protocolo paso a paso', '100% digital', 'Acceso inmediato', 'Pago único'];
export function UrgencyBar() {
  return <div className="w-full bg-brand-deep px-3 py-1.5" data-id="element-193" data-mp="3cvxvaq0s0x0m">
      <ul className="mx-auto flex max-w-4xl flex-wrap items-center justify-center gap-x-1.5 gap-y-0.5 text-center font-display text-[0.55rem] font-extrabold uppercase leading-tight tracking-wider text-violet-100 sm:text-[0.68rem]" data-id="element-194" data-mp="37va8yhnht4cq">
        {items.map((item, i) => <li key={item} className="flex items-center gap-1.5" data-id="element-195" data-mp="2u4om6hux4a9k" data-mpi={i}>
            {i > 0 && <span aria-hidden="true" className="text-accent" data-id="element-196" data-mp="2u2tywww6c62b">
                •
              </span>}
            <span data-id="element-197" data-mp="2k6qzhyspilj2">{item}</span>
          </li>)}
      </ul>
    </div>;
}